import { Search } from '@mui/icons-material';
import { InputBase, Stack } from '@mui/material';
import { useHelpCenterTFunction } from '@retail/help-center/i18n';
import React from 'react';
import { searchElementSx } from './searchElementSx';

interface Props {
  value: string;
  onChange: (value: string) => void;
}

export const SearchInput: React.FC<Props> = ({ value, onChange }) => {
  const t = useHelpCenterTFunction();

  return (
    <Stack direction="row" spacing={2} sx={searchElementSx}>
      <Search />
      <InputBase
        value={value}
        autoFocus
        placeholder={t('helpCenter.search')}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </Stack>
  );
};
